import React, { useRef, useEffect, useState } from 'react';
import {
  Container,
  Grid,
  TextField,
  Typography,
  IconButton,
  Button,
} from '@mui/material';
import { Autocomplete } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useStateValue } from '../../contexto/store';
import style from '../Tools/Style';
import ModalClientes from '../GestionDeClientes/ModalClientes';
import NumberFormat from 'react-number-format';
import { obtenerClientes } from '../../actions/ClientesAction';
import moment from 'moment';
import { registrarPresupuesto } from '../../actions/PresupuestosAction';
import { obtenerListaUsuarios } from '../../actions/UsuariosAction';
import { RegistrarAccion } from '../../actions/AuditoriaAction';

function NumberFormatCustom(props) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator="."
      decimalSeparator={false}
      isNumericString
    />
  );
}

export default function NuevoPresupuesto(props) {
  const [datosCargados,setDatosCargados]=useState(false);
  const mounted = useRef(true);
  //eslint-disable-next-line
  const [{ sesionUsuario }, dispatch] = useStateValue();
  const [usuario, setUsuario] = useState('');
  const [userName, setUserName] = useState('');
  const [asignar, setAsignar] = useState(false);
  const [dataUsu, setDataUsu] = useState([]);
  const [modalBuscar, setModalBuscar] = useState(false);
  const [Datacl, setDatacl] = useState([]);
  const [presupuesto, setPresupuesto] = useState({
    CODPRESUPUESTO: '',
    USUARIOASIGNADO: '',
    NUMEROCOMPROBANTE: '',
    FECHACOMPROBANTE: '',
    TOTALPRESUPUESTO: 0,
    CLIENTE_ID: '',
    CLIENTE: '',
  });
  const abrirModal = () => {
    setModalBuscar(true);
  };
  const cerrarModal = () => {
    setModalBuscar(false);
  };
  const ingresarValoresMemoria = (e) => {
    const { name, value } = e.target;
    setPresupuesto((anterior) => ({
      ...anterior,
      [name]: value,
    }));
  };
  const nuevoPresupuesto = () => {
    let objeto = {};
    if (
      presupuesto.CODPRESUPUESTO !== '' &&
      presupuesto.NUMEROCOMPROBANTE !== '' &&
      presupuesto.FECHACOMPROBANTE !== '' &&
      presupuesto.FECHACOMPROBANTE !== 'Invalid date' &&
      presupuesto.TOTALPRESUPUESTO !== 0 &&
      presupuesto.CLIENTE_ID !== ''
    ) {
      if (!asignar) {
        objeto = {
          CODPRESUPUESTO: presupuesto.CODPRESUPUESTO,
          USUARIOASIGNADO: sesionUsuario.usuario.nombrecompleto,
          NUMEROCOMPROBANTE: presupuesto.NUMEROCOMPROBANTE,
          FECHACOMPROBANTE: presupuesto.FECHACOMPROBANTE,
          VENDEDOR: sesionUsuario.usuario.nombrecompleto,
          TOTALPRESUPUESTO: parseInt(presupuesto.TOTALPRESUPUESTO),
          CLIENTEId: presupuesto.CLIENTE_ID,
          UserName: sesionUsuario.usuario.userName,
        };
      } else {
        objeto = {
          CODPRESUPUESTO: presupuesto.CODPRESUPUESTO,
          USUARIOASIGNADO: usuario,
          NUMEROCOMPROBANTE: presupuesto.NUMEROCOMPROBANTE,
          FECHACOMPROBANTE: presupuesto.FECHACOMPROBANTE,
          VENDEDOR: sesionUsuario.usuario.nombrecompleto,
          TOTALPRESUPUESTO: parseInt(presupuesto.TOTALPRESUPUESTO),
          CLIENTEId: presupuesto.CLIENTE_ID,
          UserName: userName,
        };
      }
      registrarPresupuesto(objeto).then((response) => {
        if (response.status === 200) {
          setPresupuesto({
            CODPRESUPUESTO: '',
            USUARIOASIGNADO: '',
            NUMEROCOMPROBANTE: '',
            FECHACOMPROBANTE: '',
            TOTALPRESUPUESTO: 0,
            CLIENTE_ID: '',
            CLIENTE: '',
          });
          dispatch({
            type: 'OPEN_SNACKBAR',
            openMensaje: {
              open: true,
              mensaje: 'Presupuesto Registrado',
            },
          });
          let objetoAudi = {
            usuario: sesionUsuario.usuario.nombrecompleto,
            accion: 'Registro',
            panel: 'Gestion de Presupuestos',
            tabla: 'PRESUPUESTOS',
            filaafectada: 'NUEVO REGISTRO',
            UsuarioId: sesionUsuario.usuario.id,
          };
          RegistrarAccion(objetoAudi);
          volver();
        }
      });
    } else {
      dispatch({
        type: 'OPEN_SNACKBAR',
        openMensaje: {
          open: true,
          mensaje: 'Todos los campos son obligatorios asegurese de llenarlos',
        },
      });
    }
  };
  const seleccionarCliente = (cliente) => {
    const id = cliente.clientE_Id;
    setPresupuesto({
      CODPRESUPUESTO: presupuesto.CODPRESUPUESTO,
      USUARIOASIGNADO: sesionUsuario.usuario.nombrecompleto,
      NUMEROCOMPROBANTE: presupuesto.NUMEROCOMPROBANTE,
      FECHACOMPROBANTE: moment(presupuesto.FECHACOMPROBANTE).format(),
      TOTALPRESUPUESTO: presupuesto.TOTALPRESUPUESTO,
      CLIENTE_ID: id,
      CLIENTE: cliente.nombre + ' ' + cliente.apellido,
    });
    setModalBuscar(false);
  };
  const volver = () => {
    props.history.goBack();
  };
  useEffect(() => {
    if (mounted.current) {
      if (props.location.state) {
        obtenerListaUsuarios().then((response) => {
          if (response.status === 200) {
            setDataUsu(response.data);
          } else {
            console.log('NO TRAJO USUARIOS');
          }
        });
        setAsignar(true);
      } else {
        setAsignar(false);
      }
      obtenerClientes().then((response) => {
        if (response.status === 200) {
          setDatacl(response.data);
          setDatosCargados(true);
        }
      });
      setPresupuesto({
        CODPRESUPUESTO: presupuesto.CODPRESUPUESTO,
        USUARIOASIGNADO: sesionUsuario.usuario.nombrecompleto,
        NUMEROCOMPROBANTE: presupuesto.NUMEROCOMPROBANTE,
        FECHACOMPROBANTE: presupuesto.FECHACOMPROBANTE,
        TOTALPRESUPUESTO: presupuesto.TOTALPRESUPUESTO,
        CLIENTE_ID: presupuesto.CLIENTE_ID,
        CLIENTE: presupuesto.CLIENTE,
      });
    }
    return function cleanup() {
      mounted.current = false;
    };
  }, [props, presupuesto, sesionUsuario]);
  return (
    <Container jsutify="center" maxWidth="md">
      <br />
      <Typography align="center" variant="h6">
        Nuevo Presupuesto
      </Typography>
      <br />
      <Grid container spacing={4}>
        <Grid item lg={6} md={6} sm={12} xs={12}>
          <TextField
            fullWidth
            variant="outlined"
            name="CODPRESUPUESTO"
            onChange={ingresarValoresMemoria}
            value={presupuesto.CODPRESUPUESTO}
            label="Codigo"
          />
        </Grid>
        <Grid item lg={6} md={6} sm={12} xs={12}>
          {asignar ? (
            <Autocomplete
              id="combo-box-demo"
              options={dataUsu}
              getOptionLabel={(dataUsu) => dataUsu.nombrecompleto}
              renderInput={(params) => (
                <TextField
                  fullWidth
                  {...params}
                  label="Buscar Usuarios"
                  variant="outlined"
                />
              )}
              onChange={(e, value) => {
                if (value === null) {
                  setUsuario('');
                  setUserName('');
                } else {
                  setUsuario(value.nombrecompleto);
                  setUserName(value.userName);
                }
              }}
            />
          ) : (
            <TextField
              fullWidth
              variant="outlined"
              name="USUARIOASIGNADO"
              value={presupuesto.USUARIOASIGNADO}
              label="Usuario"
            />
          )}
        </Grid>
        <Grid item lg={6} md={6} sm={12} xs={12}>
          <TextField
            fullWidth
            variant="outlined"
            name="NUMEROCOMPROBANTE"
            onChange={ingresarValoresMemoria}
            value={presupuesto.NUMEROCOMPROBANTE}
            label="Nro Comprobante"
          >
            Nro Comprobante
          </TextField>
        </Grid>
        <Grid item lg={6} md={6} sm={12} xs={12}>
          <TextField
            fullWidth
            variant="outlined"
            name="FECHACOMPROBANTE"
            onChange={ingresarValoresMemoria}
            value={presupuesto.FECHACOMPROBANTE}
            InputLabelProps={{ shrink: true }}
            label="Fecha del comprobante"
            type="date"
          ></TextField>
        </Grid>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <TextField
            fullWidth
            variant="outlined"
            name="TOTALPRESUPUESTO"
            onChange={ingresarValoresMemoria}
            value={presupuesto.TOTALPRESUPUESTO}
            label="Total del Presupuesto"
            InputProps={{
              inputComponent: NumberFormatCustom,
            }}
          >
            Total del Presupuesto
          </TextField>
          <br />
        </Grid>
        <IconButton
          onClick={abrirModal}
          style={style.iconbutton}
          aria-label="buscar"
        >
          <SearchIcon />
        </IconButton>
        <Grid style={style.textTarea}>
          <TextField
            disabled={true}
            name="CLIENTE"
            value={presupuesto.CLIENTE}
            multiline
            fullWidth
            variant="outlined"
            label="CLIENTE"
          />
        </Grid>
        <Grid item lg={6} md={6} sm={12} xs={12}>
          <Button
            style={style.submit}
            variant="contained"
            color="primary"
            onClick={nuevoPresupuesto}
          >
            Guardar
          </Button>
        </Grid>
        <Grid item lg={6} md={6} sm={12} xs={12}>
          <Button
            style={style.submit}
            variant="contained"
            color="primary"
            onClick={volver}
          >
            Volver
          </Button>
        </Grid>
      </Grid>
      <Grid container direction="row" justify="center" alignItems="center">
        <ModalClientes
          data={Datacl}
          open={modalBuscar}
          handleClose={cerrarModal}
          seleccionarCliente={seleccionarCliente}
          datosCargados={datosCargados}
        />
      </Grid>
    </Container>
  );
}
